import { render, staticRenderFns } from "./addPackageForm.vue?vue&type=template&id=23d47844"
import script from "./addPackageForm.vue?vue&type=script&lang=js"
export * from "./addPackageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d47844')) {
      api.createRecord('23d47844', component.options)
    } else {
      api.reload('23d47844', component.options)
    }
    module.hot.accept("./addPackageForm.vue?vue&type=template&id=23d47844", function () {
      api.rerender('23d47844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/csg/sku/components/addPackageForm.vue"
export default component.exports